import React from 'react';

import { AllClientDatasetDefinitions } from './AllClientDatasetDefinitions';

export interface ClientDatasetsPreviewProps {
    datasetId: number;
}

export const ClientDatasetsPreview: React.FC<ClientDatasetsPreviewProps> = ({ datasetId }) => (
    <AllClientDatasetDefinitions title='Preview' datasetId={datasetId} isPreview />
);
